import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Track = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.4375 14.0625C23.4375 13.1996 24.1371 12.5 25 12.5C25.8629 12.5 26.5625 13.1996 26.5625 14.0625V20.3125C26.5625 21.1754 25.8629 21.875 25 21.875C24.1371 21.875 23.4375 21.1754 23.4375 20.3125V14.0625ZM23.4375 29.6875C23.4375 28.8246 24.1371 28.125 25 28.125C25.8629 28.125 26.5625 28.8246 26.5625 29.6875V35.9375C26.5625 36.8004 25.8629 37.5 25 37.5C24.1371 37.5 23.4375 36.8004 23.4375 35.9375V29.6875ZM28.125 25C28.125 24.1371 28.8246 23.4375 29.6875 23.4375H35.9375C36.8004 23.4375 37.5 24.1371 37.5 25C37.5 25.8629 36.8004 26.5625 35.9375 26.5625H29.6875C28.8246 26.5625 28.125 25.8629 28.125 25ZM12.5 25C12.5 24.1371 13.1996 23.4375 14.0625 23.4375H20.3125C21.1754 23.4375 21.875 24.1371 21.875 25C21.875 25.8629 21.1754 26.5625 20.3125 26.5625H14.0625C13.1996 26.5625 12.5 25.8629 12.5 25ZM6.25 14.0625C6.25 14.9254 5.55044 15.625 4.6875 15.625C3.82456 15.625 3.125 14.9254 3.125 14.0625V6.25C3.12583 5.42145 3.45533 4.62708 4.0412 4.0412C4.62708 3.45533 5.42145 3.12583 6.25 3.125H14.0625C14.9254 3.125 15.625 3.82456 15.625 4.6875C15.625 5.55044 14.9254 6.25 14.0625 6.25H7.8125C6.94956 6.25 6.25 6.94956 6.25 7.8125V14.0625ZM15.625 45.3125C15.625 46.1754 14.9254 46.875 14.0625 46.875H6.25C5.42145 46.8742 4.62708 46.5447 4.0412 45.9588C3.45533 45.3729 3.12583 44.5785 3.125 43.75V35.9375C3.125 35.0746 3.82456 34.375 4.6875 34.375C5.55044 34.375 6.25 35.0746 6.25 35.9375V42.1875C6.25 43.0504 6.94956 43.75 7.8125 43.75H14.0625C14.9254 43.75 15.625 44.4496 15.625 45.3125ZM43.75 46.875H35.9375C35.0746 46.875 34.375 46.1754 34.375 45.3125C34.375 44.4496 35.0746 43.75 35.9375 43.75H42.1875C43.0504 43.75 43.75 43.0504 43.75 42.1875V35.9375C43.75 35.0746 44.4496 34.375 45.3125 34.375C46.1754 34.375 46.875 35.0746 46.875 35.9375V43.75C46.8742 44.5785 46.5447 45.3729 45.9588 45.9588C45.3729 46.5447 44.5785 46.8742 43.75 46.875ZM46.875 14.0625C46.875 14.9254 46.1754 15.625 45.3125 15.625C44.4496 15.625 43.75 14.9254 43.75 14.0625V7.8125C43.75 6.94956 43.0504 6.25 42.1875 6.25H35.9375C35.0746 6.25 34.375 5.55044 34.375 4.6875C34.375 3.82456 35.0746 3.125 35.9375 3.125H43.75C44.5785 3.12583 45.3729 3.45533 45.9588 4.0412C46.5447 4.62708 46.8742 5.42145 46.875 6.25V14.0625Z"
        fill={color}
      />
    </svg>
  )
}
